function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import T from "prop-types";
import GenericNode from "../core/GenericNode";

var Question = /*#__PURE__*/function (_GenericNode) {
  _inheritsLoose(Question, _GenericNode);

  function Question() {
    return _GenericNode.apply(this, arguments) || this;
  }

  var _proto = Question.prototype;

  _proto.getSchemaOrgType = function getSchemaOrgType() {
    return "Question";
  };

  return Question;
}(GenericNode);

Question.propTypes = {
  type: T.oneOf(["mainEntity"]),
  upvoteCount: T.number,
  dateCreated: T.string,
  dateModified: T.string,
  keywords: T.string,
  name: T.string,
  text: T.string,
  answerCount: T.number
};
export default Question;